var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.qrCodeShow,"width":"400px","center":""},on:{"close":_vm.closeDia}},[_c('div',{staticClass:"img-wrap"},_vm._l((_vm.params.list),function(item,idx){return _c('el-image',{key:idx,attrs:{"src":item.image,"fit":"fill"},on:{"click":function($event){return _vm.itemClick(item)}}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }